import * as React from 'react';
import * as ReactGA from 'react-ga';
import { CommonRootState } from '../combineReducers';
import { connect } from 'react-redux';
import { fetchServerTokensIfNeeded } from '../actions/serverTokens';
import { PECEnv } from '../interfaces/serverTokens';
import { RootActions } from '../combineActions';
import { RouteComponentProps } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';

const { beta, production } = PECEnv;

const mapStateToProps = ({ serverTokens: { serverTokens } }: CommonRootState) => ({ serverTokens });

const mapDispatchToProps = (dispatch: ThunkDispatch<CommonRootState, null, RootActions>) => ({
  fetchServerTokensIfNeeded: () => dispatch(fetchServerTokensIfNeeded())
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps;

class TrackersContainer extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    fetchServerTokensIfNeeded();
  }

  componentDidUpdate(prevProps: Props) {
    const { serverTokens } = this.props;
    const { pathname, search } = window.location;

    if (serverTokens && !prevProps.serverTokens) {
      ReactGA.initialize(
        {
          [beta]: 'UA-98996257-6',
          [production]: 'UA-98996257-7'
        }[serverTokens.pecEnv] || 'UA-98996257-5'
      );
    }

    ReactGA.pageview(`${pathname}${search}`);
  }

  render() {
    return null;
  }
}

export const Trackers = connect(mapStateToProps, mapDispatchToProps)(TrackersContainer);
